import script from "./records.vue?vue&type=script&setup=true&lang=js"
export * from "./records.vue?vue&type=script&setup=true&lang=js"

import "./records.vue?vue&type=style&index=0&id=75027558&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75027558"]])

export default __exports__